<template>
  <div>
    <h1>既にご入力いただいております。</h1>
    <p>ご登録内容に変更がある場合は、お電話でご連絡ください。</p>
    <p>電話：
    <template v-if="!ispc">
      <a href="tel:0120-945-991">0120-945-991</a>
      <br>（年末年始除く <time>9:15～21:00</time> ）
    </template>
    <template v-else>
      0120-945-991
      （年末年始除く <time>9:15～21:00</time> ）
    </template>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "submitted",
  computed: {
    ...mapGetters(["ispc"])
  },
  props: ["templateType"]
};
</script>



// WEBPACK FOOTER //
// src/components/Submitted.vue